module.exports = __webpack_public_path__ + "img/107058.e30b09fc.png";